import React from "react";
import { Link } from "react-router-dom";
import { FaYoutube, FaInstagram, FaFacebook } from "react-icons/fa";
import { MdEmail, MdPhone, MdAccessTime } from "react-icons/md";

const Footer = () => {
  const menuLinks = [
    { name: "Home", path: "/" },
    { name: "Facilities", path: "/facilities" },
    { name: "Gallery", path: "/gallery" },
    { name: "Apply & Enroll", path: "/enroll" },
  ];

  const socials = [
    {
      href: "https://www.youtube.com/@galaxystarschool",
      icon: <FaYoutube />,
      label: "YouTube",
      hoverColor: "#ef4444",
    },
    {
      href: "https://www.instagram.com/galaxystarschool/",
      icon: <FaInstagram />,
      label: "Instagram",
      hoverColor: "#f472b6",
    },
    {
      href: "https://www.facebook.com/p/Galaxy-Star-Public-School-Sekhwan-100057501486855/",
      icon: <FaFacebook />,
      label: "Facebook",
      hoverColor: "#93c5fd",
    },
  ];

  return (
    <footer className="relative bg-[#020810] pt-24 pb-12 overflow-hidden">
      {/* Cosmic background effects */}
      <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-gold/30 to-transparent" />
      <div className="absolute bottom-0 right-0 w-[500px] h-[500px] bg-gold/5 blur-[120px] rounded-full pointer-events-none translate-x-1/2 translate-y-1/2" />

      <div className="max-w-7xl mx-auto px-6 relative z-10">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-16 mb-20">
          {/* ── Brand Section ── */}
          <div className="lg:col-span-1">
            <Link to="/" className="flex items-center gap-4 mb-8 group">
              <div className="relative rounded-full p-[2px] bg-gradient-to-tr from-gold to-gold-light">
                <div className="rounded-full bg-[#020810] p-1">
                  <img
                    src="/renamed_website_images/school-logo.png"
                    alt="Logo"
                    className="w-12 h-12 object-contain rounded-full"
                  />
                </div>
              </div>
              <div>
                <h4
                  className="text-white font-black uppercase tracking-widest text-sm"
                  style={{ fontFamily: "Orbitron, sans-serif" }}
                >
                  Galaxy Star
                </h4>
                <p className="text-gold font-bold uppercase tracking-[0.2em] text-[10px]">
                  Public School
                </p>
              </div>
            </Link>
            <p className="text-gray-400 text-sm leading-relaxed mb-8">
              Empowering students to reach for the stars through academic
              excellence, character building, and innovative learning in a
              cosmic-inspired environment.
            </p>
            <div className="flex items-center gap-4">
              {socials.map((social, i) => (
                <a
                  key={i}
                  href={social.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-10 h-10 rounded-xl bg-white/5 border border-white/10 flex items-center justify-center text-gray-400 hover:text-gold hover:border-gold/50 transition-all duration-300"
                >
                  {social.icon}
                </a>
              ))}
            </div>
          </div>

          {/* ── Quick Links ── */}
          <div>
            <h4
              className="text-white font-bold uppercase tracking-[0.2em] text-xs mb-8"
              style={{ fontFamily: "Orbitron, sans-serif" }}
            >
              Quick Navigation
            </h4>
            <ul className="space-y-4">
              {menuLinks.map((link, i) => (
                <li key={i}>
                  <Link
                    to={link.path}
                    className="text-gray-400 hover:text-gold text-sm font-medium transition-colors flex items-center gap-2 group"
                  >
                    <span className="w-1.5 h-px bg-gold/50 group-hover:w-4 transition-all" />
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* ── Contact Info ── */}
          <div>
            <h4
              className="text-white font-bold uppercase tracking-[0.2em] text-xs mb-8"
              style={{ fontFamily: "Orbitron, sans-serif" }}
            >
              Contact Details
            </h4>
            <ul className="space-y-6">
              <li className="flex gap-4">
                <div className="w-10 h-10 rounded-xl bg-gold/10 border border-gold/20 flex items-center justify-center text-gold shrink-0">
                  <MdPhone size={20} />
                </div>
                <div>
                  <p className="text-white font-bold text-xs uppercase tracking-widest mb-1">
                    Phone Number
                  </p>
                  <p className="text-gray-400 text-sm">+91 90413 21493</p>
                </div>
              </li>
              <li className="flex gap-4">
                <div className="w-10 h-10 rounded-xl bg-gold/10 border border-gold/20 flex items-center justify-center text-gold shrink-0">
                  <MdEmail size={20} />
                </div>
                <div>
                  <p className="text-white font-bold text-xs uppercase tracking-widest mb-1">
                    Email Address
                  </p>
                  <p className="text-gray-400 text-sm">
                    info@galaxystarschool.com
                  </p>
                </div>
              </li>
            </ul>
          </div>

          {/* ── Working Hours ── */}
          <div>
            <h4
              className="text-white font-bold uppercase tracking-[0.2em] text-xs mb-8"
              style={{ fontFamily: "Orbitron, sans-serif" }}
            >
              Academic Hours
            </h4>
            <div className="p-6 rounded-3xl bg-white/5 border border-white/10">
              <div className="flex items-center gap-3 mb-4">
                <MdAccessTime className="text-gold" size={20} />
                <span className="text-white font-bold text-xs uppercase tracking-widest">
                  Office Hours
                </span>
              </div>
              <p className="text-gray-400 text-sm mb-2">
                Mon - Sat: 8:00 AM - 3:00 PM
              </p>
              <p className="text-gold font-bold text-[10px] uppercase tracking-widest">
                Sunday: Closed
              </p>
            </div>
          </div>
        </div>

        {/* ── Bottom Copyright ── */}
        <div className="pt-12 border-t border-white/5 flex flex-col md:flex-row justify-between items-center gap-6">
          <p className="text-gray-500 text-xs font-medium uppercase tracking-widest">
            © 2026 Galaxy Star Public School. All Rights Reserved.
          </p>
          <div className="flex gap-8">
            <span
              className="text-gray-500 hover:text-white text-[10px] font-bold uppercase tracking-[0.2em] transition-colors cursor-pointer"
            >
              Privacy Policy
            </span>
            <span
              className="text-gray-500 hover:text-white text-[10px] font-bold uppercase tracking-[0.2em] transition-colors cursor-pointer"
            >
              Terms of Service
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
